import pagesNames from "../../constants/pages-names";

const environmentPageDataAr = {
    header : {
        image : {
            name : "environment.jpg",
            alt : "Lake in front of hills",
        },
        title : "الأثر البيئي",
    },
    sectionOne : {
        title : "الأثر البيئي",
        borderBox : {
            title : "الهدف الشامل",
            subtitle : "تخصيص التمويل من أجل اقتصاد عادل ومستدام."
        },
        paraghraphOne : "ساهمت الحلول المصرفية والاستثمارية المبتكرة التي قدمها بنك الأول خلال السنوات الـ 40 الماضية في نمو الاقتصاد الوطني والقطاع المالي. يطمح بنك الأول خلال الـ 40 عاماً مقبلة بأن يلعب دوراً فاعلاً ومؤثراً في تحفيز الاقتصاد المستدام الناشئ. ندرك في بنك الأول أن هذا التحول الاقتصادي سيوفر فرصة هائلة للنمو المستدام. ومع بداية تنفيذ المشاريع الضخمة داخل الدولة، عززت المملكة مكانتها الريادية في مجال الاستدامة على الصعيد العالمي. ويشمل ذلك مصادر الطاقة المتجددة، والهيدروجين الأخضر، والسياحة المستدامة، وعزل الكربون.",
        paraghraphTwo : "يتوقع شركاؤنا وأصحاب المصلحة أن يدار بنك المخاطر المتعلقة بالحوكمة البيئية والاجتماعية و المؤسسية بكفاءة عالية، بالإضافة إلى استغلال الفرص التي تتيحها هذه الممارسات بالشكل الأمثل. وحتى الآن، أثبتت تجاربنا في مجال الاستدامة أنه من الممكن تحقيق الاستدامة والنمو المربح بشكل متزامن. نطمح لأن نكون البنك المفضل للعملاء الراغبين في تحويل أعمالهم إلى نموذج أعمال اقتصاد دائري من خلال الاستفادة من منتجاتنا وخدماتنا المالية التي تم تطويرها بشكل خاص لتلبية هذه الغاية",
        paragraphThree : "نثق في بنك الأول بأن الجميع لديهم فرصة الاستفادة من أرباح الاقتصاد المستدام. يتمثل دورنا في دعم رؤية السعودية 2030، وتعزيز المشاركة الاقتصادية، وبناء اقتصاد شمولي يلبي احتياجات المنشآت المتناهية الصغر والصغيرة والمتوسطة وقاعدة متنوعة من العملاء. وإلى جانب الدور الاقتصادي الذي يؤديه بنك الأول في التمويل الأخضر والمستدام، يعتزم البنك في أن يكون له دور مؤثر داخل المجتمع المالي. تمنحنا شراكتنا الاستراتيجية مع إتش إس بي سي فرصة استثنائية لاستقطاب المواهب وأصحاب المعرفة وأفضل ممارسات الحوكمة البيئية والاجتماعية و المؤسسية إلى قطاع الخدمات المالية في المملكة العربية السعودية.",
        paragraphFour : "وقد واصلنا تعزيز خطتنا في مجال الحوكمة البيئية والاجتماعية و المؤسسية من خلال المشاركة في منتديات أصحاب المصلحة مثل مؤتمر المناخ 2022 (COP 27) الذي عُقد في شرم الشيخ بمصر. ويمثل ذلك دليلاً واضحاً على استعدادنا للمشاركة في تعزيز الاقتصادات المستدامة وترسيخ أفضل الممارسات الصناعية.",
    },
    centerTitle : "مجالات التركيز",
    sectionTow : [
        {
            icon : "box.svg",
            title : "منتجات وخدمات مستدامة",
            subtitle : "دعم انتقال العملاء"
        },
        {
            icon : "money.svg",
            title : "التمويل والاستثمارات المستدامة",
            subtitle : "دمج معايير الاستدامة البيئية في محفظتنا التمويلية"
        },
        {
            icon : "target.svg",
            title : "تحقيق الحياد الكربوني",
            subtitle : "تحويل عملياتنا وسلسلة التوريد لدينا"
        },
        {
            icon : "co2.svg",
            title : "تعويض ثاني أكسيد الكربون",
            subtitle : "زرع مليون شجرة"
        },
    ],
    subsection : {
        paragraphOne : "تسعى رؤية 2030 إلى الحفاظ على البيئة الطبيعية للمملكة وتعزيزها، وتحقيق الحياد الكربوني وتصفير الانبعاثات بحلول عام 2060. وتتوافق استراتيجيتنا مع برنامج رؤية السعودية 2030 جنباً إلى جنب مع الطموح لتحقيق صافي انبعاثات كربونية صفرية بحلول العام 2060، مع الالتزام بالوصول إلى صافي انبعاثات صفرية في العمليات التجارية بحلول عام 2040. ولتحقيق هذا الهدف، نلتزم بتوظيف 34 مليار ريال سعودي من رأس المال في التمويل والاستثمارات المستدامة عبر أعمالنا في مجالي الأفراد والشركات. كما نسعى إلى فهم رحلة عملائنا نحو الاستدامة، واستخدام هذه المعرفة لتقديم الدعم الذي يلزمهم لتحقيق النجاح. وضمن هذه الجهود، نشرنا الاستبيان الخاص بالمشاركة في التحول لدعم فرق الخطوط الأمامية من جمع المعلومات التي تركز على المخاطر المادية والانتقالية من عملائنا. نتعاون عن كثب مع موردي المنتج النهائي وسلسلة التوريد لدينا، نقوم بمراجعة عقودنا بهدف حث الأطراف الثالثة على تقييم تأثيراتها البيئية والحد منها.",
        paragraphTwo : "نظرا لأننا نسيطر بشكل مباشر على انبعاثات النطاق 1 ضمن عملياتنا، فقط أطلقنا سلسلة من البرامج لتحقيق تأثير ملموس وإيجابي.",
        paragraphThree : "وتشمل هذه البرامج تقليل النفايات والورق والبلاستيك واستخدام الطاقة. كما قمنا بتقليل رحلات العمل الخاصة بالبنك إلى الحد الأدنى، واستبدالها بالاجتماعات عن بعد كلما كان ذلك ممكناً. أما خارج نطاق البنك، فقد كثفنا تعاوننا مع مبادرة السعودية الخضراء، وركزنا جهودنا للانسجام مع العديد من المبادرات البيئية المستدامة، وذلك من خلال شراكات مع منظمات غير ربحية وهيئات حكومية.",
        borderLeftBox : {
            title : 'تحقيق العديد من "المراكز الأولى"',
            subtitle : 'أطلق بنك الأول في عامي 2021 - 2022 منتجين جديدين يستهدفان سوق الخدمات المصرفية للأفراد. يشكل المنتج الأول صندوق استثماري جديد ومبتكر يركز على الاستثمارات الداعمة لتقليل تأثير التغير المناخي. أما المنتج الثاني فهو إسلامي بالكامل، وهو حساب الودائع الخضراء المتوافق مع أحكام الشريعة الإسلامية لأغراض الحوكمة البيئية والاجتماعية والمؤسسية. وتعد هذه المنتجات "الأولى" من نوعها في المملكة العربية السعودية، ومن بين الأولى في العالم لودائع الحوكمة البيئية والاجتماعية والمؤسسية المتوافقة مع أحكام الشريعة الإسلامية.',
        },
    },
    sectionSix : {
        title : "دعم الشركات الصغيرة",
        titleBorderLeft : "لمحة عامة",
        paragraphOne : "تعد المنشآت المتناهية الصغر والصغيرة والمتوسطة أحد المحفزات المهمة للتنمية الاقتصادية باعتبارها الرافعة المالية الأولى للدخل بين رواد الأعمال الناشئين. تهدف المملكة العربية السعودية إلى رفع مساهمة المنشآت المتناهية الصغر والصغيرة والمتوسطة في إجمالي النتاج المحلي من 20% التي كانت موجودة عند إطلاق خطة رؤية 2030 في عام 2016 إلى 35%. واعترافاً بالدور الهام الذي تؤديه الشركات المتناهية الصغر والصغيرة والمتوسطة في الاقتصادات الوطنية، تعهد بنك الأول بتقديم دعم شامل لهذا القطاع من الأعمال. يشارك البنك في العديد من المبادرات الحكومية الرامية إلى توسع نطاق الشمول المالي ليتضمن الشركات متناهية الصغر والصغيرة والمتوسطة.",
        paragraphTwo : 'وخلال العام 2022، وفي إطار من التزام الأول بدعم رؤية السعودية 2030، قدم البنك أولى حلقاته في سلسلة من الندوات التوعوية للمنشآت متناهية الصغر والصغيرة والمتوسطة للمساهمة في التثقيف بشأن الجوانب المختلفة لتطوير وتنمية هذه المنشآت في المملكة. كما شارك البنك في تمويل ودعم المشاريع المتناهية الصغر والصغيرة والمتوسطة. وشملت المبادرات الرئيسية توقيع اتفاقية تعاون مع بنك المنشآت الصغيرة والمتوسطة في المملكة، والهيئة العامة للمنشآت الصغيرة والمتوسطة "منشآت". وبالإضافة إلى بنك المشروعات المتناهية الصغر والصغيرة والمتوسطة و"منشآت"، دعم الأول أيضاً المنشآت متناهية الصغر والصغيرة والمتوسطة من خلال مشاركته مع كل من صندوق التنمية العقاري، وصندوق التنمية السياحي، والبرنامج الوطني لتنمية تقنية المعلومات.',
        paragraphThree : "وفيما يتعلق بالخدمات المصرفية، يواصل بنك الأول العمل على استعراض وتطوير المنتجات التي تدعم الشركات المتناهية الصغر والصغيرة والمتوسطة في كل مرحلة من مراحل نموها. وتشمل هذه الخدمات تمويل نقاط البيع ورأس المال العامل وتمويل قطاع تكنولوجيا المعلومات وتمويل الرواتب. وبالتالي، شهدت قاعدة عملائنا المتنامية من المشروعات المتناهية الصغر والصغيرة والمتوسطة نمواً متسارعاً منذ عام 2020. ويعزى ذلك إلى المجموعة المتنامية من العروض والمنتجات التي نقدمها، بما في ذلك المنتجات المتوافقة مع الشريعة الإسلامية.",
        paragraphFour : "يفخر بنك الأول بدعمه لما يزيد على 15,000 عميل نشط من شريحة المنشآت المتناهية الصغر والصغيرة والمتوسطة من خلال عروضه ومنتجاته الرقمية. ولدى بنك الأول ثمانية مراكز تخدم عملاء المنشآت المتناهية الصغر والصغيرة والمتوسطة المنتشرة في الرياض وجدة والدمام والقصيم. كما يوجد لدى الأول أكثر من 70 موظفاً مخصصاً لتقديم الدعم للمنشآت المتناهية الصغر والصغيرة والمتوسطة. يدير فئات المنشآت المتناهية الصغر والصغيرة والمتوسطة في بنك الأول فريقان، فريق فئة المنشآت الصغيرة ومتناهية الصغر والذي يدعم المنشآت المتناهية الصغر والصغيرة والمتوسطة التي يقلّ حجم مبيعاتها عن 40 مليون ريال سعودي، وفريق فئة المنشآت المتوسطة التي تقدم خدماتها للعملاء بحجم مبيعات يتراوح بين 40 مليون ريال سعودي و200 مليون ريال سعودي. ويُعرّف بنك الأول فئات المنشآت متناهية الصغر والصغيرة والمتوسطة على النحو التالي: المنشآت متناهية الصغر (أقل من 3 ملايين ريال سعودي في حجم الأعمال السنوي)، والمنشآت الصغيرة (من 3 ملايين ريال سعودي إلى 40 مليون ريال سعودي)، والمنشآت المتوسطة (من 40 مليون ريال سعودي إلى 200 مليون ريال سعودي).",
        chartOneSection : {
            title : "Number of MSME customers with credit facilities",
            chart : {
                data : [
                    {
                        label : "2020",
                        cols : [{
                            number : 404,
                            color : "blue",
                        },{
                            number : 236,
                            color : "gray",
                        },{
                            number : 109,
                            color : "green"
                        }],
                    },
                    {
                        label : "2020",
                        cols : [{
                            number : 457,
                            color : "blue",
                        },{
                            number : 465,
                            color : "gray",
                        },{
                            number : 370,
                            color : "green"
                        }],
                    },
                    {
                        label : "2020",
                        cols : [{
                            number : 444,
                            color : "blue",
                        },{
                            number : 506,
                            color : "gray",
                        },{
                            number : 369,
                            color : "green"
                        }],
                    },
                ],
                xAxis : [0, 100, 200, 300, 400, 500, 600],
                labels : [
                    {
                        name : "المتناهية الصغر",
                        color : "green",
                    },
                    {
                        name : "الصغيرة",
                        color : "gray",
                    },
                    {
                        name : "المتوسطة",
                        color : "blue",
                    },
                ],
            }
        },
        chartSectionTwo : {
            title : "مكونات محفظة القروض (قيمة محفظة القروض حسب الحجم (مليون ريال))",
            chartOne : {
                title : "المنشآت الصغيرة والمتوسطة",
                cols : [
                    {
                        year : "2022",
                        color : "blue",
                        value : 1616,
                    },
                    {
                        year : "2021",
                        color : "gray",
                        value : 1119,
                    },
                    {
                        year : "2020",
                        color : "gray",
                        value : 834,
                    },
                ],
                xAxis : ["0", "5,00", "1,000", "1,500", "2,000"],
                maxValue : 2000,
            },
            chartTwo : {
                title : "المنشآت المتناهية الصغر",
                cols : [
                    {
                        year : "2022",
                        color : "blue",
                        value : 9269,
                    },
                    {
                        year : "2021",
                        color : "gray",
                        value : 5993,
                    },
                    {
                        year : "2020",
                        color : "gray",
                        value : 5499,
                    },
                ],
                xAxis : ["0", "4,000", "8,000", "10,000", "12,000"],
                maxValue : 12000,
            },
            chartThree : {
                title : "المنشآت الكبيرة وغيرها",
                cols : [
                    {
                        year : "2022",
                        color : "blue",
                        value : 130662,
                    },
                    {
                        year : "2021",
                        color : "gray",
                        value : 126527,
                    },
                    {
                        year : "2020",
                        color : "gray",
                        value : 116284,
                    },
                ],
                xAxis : ["0", "110,000", "120,000", "130,000", "140,000"],
                maxValue : 140000,
            },
        }
    },
    sectionSeven : {
        borderTitleOne : "مشاريع دعم المنشآت متناهية الصغر والصغيرة والمتوسطة",
        subSections : [
            {
                title : 'البرامج التي يدعمها البنك المركزي السعودي "ساما"',
                subtitle : "مدد البنك المركزي السعودي برنامجه لدعم تمويل القطاع الخاص للمنشآت المتناهية الصغر والصغيرة والمتوسطة حتى مارس 2023. يستهدف برنامج البنك المركزي السعودي دعم المنشآت المتناهية الصغر والصغيرة والمتوسطة التي تواجه تحديات نتيجة جائحة فيروس كورونا المستجد كوفيد-19. ومنذ عام 2020، قدّم البرنامج مساعدة لأكثر من 13,000 شركة بقيمة إجمالية تجاوزت 11 مليار ريال سعودي. ويمكن الاستفادة من البرنامج من خلال البنوك والجهات التمويلية التي تخضع لرقابة المصرف المركزي. ويفخر بنك الأول ، بصفته أحد البنوك الرائدة التي تقدم خدماتها لهذه الشريحة من العملاء أن يشارك في هذا البرنامج.",
            },
            {
                title : "كفالة",
                subtitle : "يسهّل برنامج كفالة إقراض الشركات المنشآت متناهية الصغر والصغيرة والمتوسطة والخدمات الموجهة لها بالتعاون مع صندوق التنمية الصناعية السعودي. يقدم بنك الأول تمويلاً يصل إلى 15 مليون ريال سعودي للعملاء المؤهلين. ويقدم الأول مجموعة متنوعة من الحلول المتوافقة مع الشريعة الإسلامية لتلبية احتياجات المنشآت متناهية الصغر والصغيرة والمتوسطة، وتمكينها من تنمية وتطوير عملياتها التجارية. ويحرص البنك على متابعة التقدم المحرز في هذا السياق من خلال فرق تقدم تقارير أسبوعية عن العملاء المحتملين الراغبين في الاستفادة من عروض المنتجات المختلفة. وتلبي منتجات التمويل المختلفة التي يقدمها برنامج كفالة احتياجات العملاء في قطاع السياحة والشركات الناشئة ورأس المال العامل، وغيرها من القطاعات الأخرى.",
            },
            {
                title : "منشآت",
                subtitle : 'تعمل الهيئة العامة للمنشآت الصغيرة والمتوسطة "منشآت" على دعم وتنمية ورعاية قطاع المنشآت متناهية الصغر والصغيرة والمتوسطة في المملكة. ويتعاون بنك الأول مع منشآت من خلال دعم عدد من مبادراتها، بما في ذلك توقيع اتفاقية للمساعدة في تطوير بوابة تمويل جديدة من شأنها تمكين عملاء المنشآت متناهية الصغر والصغيرة والمتوسطة من الحصول على فرص تمويلية. وتسهم مذكرة التفاهم، التي أُبرمت خلال السنة المالية الماضية، في تعزيز الشراكة بين الطرفين وتمهد الطريق نحول مزيد من التعاون في المستقبل',
            },
            {
                title : "بنك المنشآت الصغيرة والمتوسطة",
                subtitle : "يقدم بنك المنشآت الصغيرة والمتوسطة الذي أطلقته منشآت منتجات وخدمات رقمية للمنشآت المتناهية الصغر والصغيرة والمتوسطة. ويعتمد بنك المنشآت الصغيرة والمتوسطة، بالتعاون مع الشركاء الدوليين، أفضل ممارسات السوق في مساعيه لبناء منتجات مناسبة لجميع فئات المنشآت متناهية الصغر والصغيرة والمتوسطة. تشمل المنتجات المقدمة تمويل رأس المال، والتمويل المضمون، والتمويل البديل. وخلال الربع الأخير من عام 2022، أبرم بنك الأول اتفاقية مع بنك المنشآت الصغيرة والمتوسطة لتنفيذ اتفاقيات تمويل مشترك للعملاء بين الأول وبنك المنشآت الصغيرة والمتوسطة. ",
            },
        ],
        borderTitleTwo : "البطاقات المصرفية الخضراء",
        paragraphOne : "وفي عام 2022، أصبح الأول أول بنك في السوق يقدم بطاقات مستدامة مصنوعة بنسبة 85% من البلاستيك المعاد تدويره. ومع تداول أكثر من 240 ألف بطاقة مصرفية في السوق، ستوفر هذه المبادرة أطناناً من المخلفات البلاستيكية، كما ستسهم في تخفيض انبعاثات الكربون. كما يقوم البنك بتمديد فترة انتهاء صلاحية بطاقات الائتمان من 3 إلى 5 بهدف تقليل استخدام البلاستيك."
    },
    sectionSevent : {   
        title : "محفظـة الإقراض المخصصة من بنك الأول",
        paragraphOne : "يهدف الأول إلى قياس الانبعاثات الكربونية لمحفظة أعماله، وضمان الوصول إلى الحياد الكربوني بحلول عام 2060 أو قبل. تماشياً مع متطلبات إعداد تقارير مجلس معايير محاسبة الاستدامة (SASB) للبنوك التجارية، يوضح الجدول التالي تفاصيل إقراض بنك الأول في 31 ديسمبر 2022.",
        borderTitle : "مقارنة المخاطر الكلية حسب القطاعات",
        chartImage : {
            image : "chart-one.png",
            alt : "",
        }
    },
    sectionEight : [
        {
            image : {
                name : "img-2.jpg",
                alt : "Light Cross the trees",
            },
            title : "Social Impact",
            subtitle : "Play a leading role to shape an inclusive and diverse society, positively impacting our stakeholders",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
        {
            image : {
                name : "img-5.jpg",
                alt : "a person using a laptop",
            },
            title : "Overarching Goal",
            subtitle : "Commitment towards a high standard of governance, driving integrity and responsibility in all decision-making.",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
        {
            image : {
                name : "img-4.jpg",
                alt : "A woman helps a child",
            },
            title : "Sustainability in Our Operations",
            subtitle : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim",
            button : {
                text : "Read More",
                path : pagesNames.home
            }
        },
    ]
};

export default environmentPageDataAr;